var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name!='Orders'&&_vm.$route.name!='Dashboard'&&_vm.$route.name!='Onboard'&&_vm.$route.name!='Performance')?_c('Nav'):_vm._e(),_c('router-view',{staticStyle:{"margin-top":"6rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }